import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Spin, message } from "antd";
import axios from "axios";
import styled from "styled-components";
import { AuthConstant } from "../../constants/AuthConstant";
import LoginBackGroundImage from "../../assets/voyager/LoginBackGroundImage.png";
import { BASEURL } from "../../BaseUrl";
import { currentEnvConfig } from "../../constants/AuthConstant";

const Login = () => {
  const navigate = useNavigate();
  const [code, setcode] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();

  const errorMessage = () => {
    messageApi.open({
      type: "error",
      content: "Not able to Authenticate",
    });
  };

  const Container = styled.div`
    background-image: url(${LoginBackGroundImage});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  `;

  const {
    client_id,
    authorization_endpoint,
    redirect_uri,
    response_type,
    response_mode,
    scope,
    state,
  } = AuthConstant[currentEnvConfig];

  const authenticateUser = async () => {
    try {
      const LOGIN_URI = `${authorization_endpoint}?client_id=${client_id}&state=${state}&response_type=${response_type}&redirect_uri=${redirect_uri}&response_mode=${response_mode}&scope=${scope}`;
      window.location.replace(LOGIN_URI);
      // navigate("/dep/dashboard", {
      //   state: {
      //     roles: ["admin"],
      //     refreshToken: "",
      //     accessToken:
      //       "eyJ0eXAiOiJKV1QiLCJub25jZSI6IlF5MlhUZGstdGN1QmpLUzM5Y25jMVBhcTlZektBOWR0ZmVqWVhmTDhzcGsiLCJhbGciOiJSUzI1NiIsIng1dCI6Il9qTndqZVNudlRUSzhYRWRyNVFVUGtCUkxMbyIsImtpZCI6Il9qTndqZVNudlRUSzhYRWRyNVFVUGtCUkxMbyJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8xZTQ1ODJlOC0yMjBhLTRmMTctOTBmMC1mZmE5NDY4N2Y3YjQvIiwiaWF0IjoxNzUzMTc3MDExLCJuYmYiOjE3NTMxNzcwMTEsImV4cCI6MTc1MzE4MTg2MCwiYWNjdCI6MCwiYWNyIjoiMSIsImFjcnMiOlsicDEiXSwiYWlvIjoiQVpRQWEvOFpBQUFBSzgxamhGN0p2bWFLMm1kYllMSUNmNWRPR09YRGtiVHdpa01JUEk3bHZOcjJLSHYxNEpwSVBES1dZUHVSYWZZVFJjUENiTzZ3K05JWjRDaUFXR2IxUFZOMUExd0Q0NnNuQndvMGxGMThyWlFUYnJ0UTRJcWZGOXF6OU1Pa2pTUTU5MzZ3WlowWFU0NTRxZXdPNWk4cTFoY1MycjNQNlQ4dk1ZYldWeDU5UmdQRmR4ZlkvcGtaRmMzQnpKK0t3ckhwIiwiYW1yIjpbInB3ZCIsIm1mYSJdLCJhcHBfZGlzcGxheW5hbWUiOiJWREVQIFVBVCIsImFwcGlkIjoiODk5N2ZkYTctZDk0Yy00NDA2LTgwNGYtYWE3NWNjYWQwN2RiIiwiYXBwaWRhY3IiOiIxIiwiZmFtaWx5X25hbWUiOiJTb25pIiwiZ2l2ZW5fbmFtZSI6Ik5hbmRpbmkiLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiIxMDMuMTE2Ljg1Ljc5IiwibmFtZSI6Ik5hbmRpbmkgU29uaSIsIm9pZCI6ImYzNzZiMjA4LTJhMGQtNGM0Zi05ZGNjLTBhMjY2OGFmMzU0MSIsIm9ucHJlbV9zaWQiOiJTLTEtNS0yMS0yMDQ4NDkwNTgwLTI4NDYwNDgxMzYtMzU5NTUyMzEwNy00MDM2MSIsInBsYXRmIjoiMyIsInB1aWQiOiIxMDAzMjAwM0U0RDIwMzdFIiwicmgiOiIxLkFXNEE2SUpGSGdvaUYwLVE4UC1wUm9mM3RBTUFBQUFBQUFBQXdBQUFBQUFBQUFCdUFPWnVBQS4iLCJzY3AiOiJlbWFpbCBvcGVuaWQgcHJvZmlsZSIsInNpZCI6IjAwNmUzMzA5LTAzY2UtNjkxYS1lYWViLWFkZWU4Nzg3YzU2YiIsInN1YiI6IlNORzNEdDFPWllBcUpweEFsQ3VuWmFsemd5WDlXZmp1U3c5S1lCNDluclEiLCJ0ZW5hbnRfcmVnaW9uX3Njb3BlIjoiTkEiLCJ0aWQiOiIxZTQ1ODJlOC0yMjBhLTRmMTctOTBmMC1mZmE5NDY4N2Y3YjQiLCJ1bmlxdWVfbmFtZSI6Im5zb25pQHZ5Z3IuY29tIiwidXBuIjoibnNvbmlAdnlnci5jb20iLCJ1dGkiOiJLbTQxZlE3OVBFU2xEUDNWejAtVkFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXSwieG1zX2Z0ZCI6ImJ1YlE1c3NyY0dfRU9sYVlYVVR6YnJHTVRtVlJaRFVQZlhHSVdBWlRtOXdCZFhObFlYTjBMV1J6YlhNIiwieG1zX2lkcmVsIjoiMTIgMSIsInhtc19zdCI6eyJzdWIiOiIyN2x4VnZBX2xqTDdzdVF6aU1TVUtmdWxFUHNXUU9sZnBna3FYdndmcVo0In0sInhtc190Y2R0IjoxMzc2MDc5MTg3fQ.dfCTF3zW348P_-1lv6GXG5Sspy0bLml78NX-odQmKsG2-WIJ7PsMp9abozThZYAX-MBwJb05bUf_aysbh68nU7jFrdTN18seKQTLzE7Vme3rdYbylHzYtdeaFMvuwoXALhygyJB6ORzbysF_Fp3GEsnT5qs0io2RUxhRD0EjFp7cKqRERU44uepZqdWTB9CwWHrnVrt5DQS3XPceNNdvDxbnjkvLdXjsYHPdcuWVdZIG0hjelIFH1NNxRk1NB0BzXIclWt4UT10PjNAyDghEiPFSSGj7SGtIvQV57dNaQoSbhLjNHBqVah3uKK1bxSgAO2yX6fW2kd4VXiHsc0nOYw",
      //     isAuthenticated: true,
      //     isAdmin: true,
      //     userId: "MZVAeNtIrf52u9vWmZZwUkL6XLGDqksnVnitFJaY0HQ",
      //     username: "Nandini Soni",
      //     email: "nsoni@vygr.com",
      //   },
      // });
    } catch (error) {
      console.log(error);
      errorMessage();
    }
  };

  const fetchToken = async (code) => {
    try {
      const loginEndpoint = AuthConstant[currentEnvConfig]?.login_endpoint;

      if (!loginEndpoint) {
        throw new Error("Login endpoint not found for the current environment");
      }

      const response = await axios.get(`${BASEURL}/${loginEndpoint}`, {
        params: { code },
      });
      if (response.status === 200) {
        navigate("/dep/dashboard", {
          state: {
            roles: response.data.roles,
            refreshToken: response.data.refreshToken,
            accessToken: response.data.accessToken,
            isAuthenticated: response.data.authenticated,
            isAdmin: response.data.admin,
            userId: response.data.userId,
            username: response.data.email,
          },
        });
      }
    } catch (error) {
      setcode(null);
      window.location.replace(AuthConstant[currentEnvConfig].redirect_uri);
    }
  };

  useEffect(() => {
    console.log("navigate called");

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    console.log("OAuth Code:", code);
    setcode(code);

    if (code) {
      fetchToken(code);
    }
  }, [navigate]);

  return (
    <>
      {code === null && (
        <>
          <Container>
            <Button type="primary" onClick={authenticateUser}>
              LOGIN
            </Button>
          </Container>
        </>
      )}
      {code !== null && (
        <>
          <Spin fullscreen tip="Loading" size="large">
            <div
              style={{
                padding: 50,
                background: "rgba(0, 0, 0, 0.05)",
                borderRadius: 4,
              }}
            />
            ;
          </Spin>
        </>
      )}
    </>
  );
};

export default Login;
